import React, { PropTypes } from 'react';
import Pagination from '../Common/Pagination';
import UsuarioItem from './UsuarioItem';
import RemoveAccents from 'remove-accents';

export default class GerenciarUsurios extends React.Component {

	constructor(props) {
		super(props);
		this.state = { isFetching: false, message: "", status: "", order: "asc",
			orderUsername: "asc", whichOrder: "nome" };
	}
	componentWillMount() {
		this.props.getListUsers();
	}

	filterByPage(array, itemsPerPage, page) {
		const endIndex = itemsPerPage * page - 1;
		const startIndex = endIndex - itemsPerPage + 1;
		return array.slice(startIndex, endIndex + 1);
	}

	getTotalPages() {
		const { itemsPerPage } = this.props.users.pagination;
		return Math.ceil(this.filterByState().length / itemsPerPage);
	}

	getTotalUsers() {
		return this.filterByState().length;
	}

	getUsers() {
		const { itemsPerPage, currentPage } = this.props.users.pagination;
		return this.filterByPage(this.filterByState(), itemsPerPage, currentPage);
	}

	termCheckerWordWrapper(term, text) {
		const regex = `(\\s(${term})\\s)`;
		return new RegExp(regex).test(text);
	}

	compareNumberToTerms(number, terms) {
		var outputID = false;
		terms.forEach((term) => {
			if (outputID === true) return;
			if (number.toString() === term) {
				outputID = true;
				return true;
			} else { return false; }
		});
		return outputID;
	}

	filterBySearchTerms(list) {
		const terms = this.props.users.filter.selectedTerms;
		if ( terms.length === 0 ) return list;

		return list.filter((user) => {
			const nome = RemoveAccents.remove(user.nome.toLowerCase().normalize());
			const sobrenome = RemoveAccents.remove(user.sobrenome.toLowerCase().normalize());
			const username = RemoveAccents.remove(user.username.toLowerCase().normalize());
			
			if (this.compareNumberToTerms(user.id, terms)) {
				return true;
			}

			if (new RegExp(terms.join("|")).test(nome)) {
				return true;
			}
			if (new RegExp(terms.join("|")).test(sobrenome)) {
				return true;
			}
			if (new RegExp(terms.join("|")).test(username)) {
				return true;
			}
			return false;
		});
	}

	compare( a, b) {
		if (a.nome === "" || a.nome === null) return 1;
		if (b.nome === "" || b.nome === null) return -1;

		if ( a.nome + " " + a.sobrenome < b.nome + " " + b.sobrenome ) {
			return -1;
		}
		if ( a.nome + " " + a.sobrenome > b.nome + " " + b.sobrenome ) {
			return 1;
		}
		return 0;

	}
	compareDesc( a, b) {
		if (a.nome === "" || a.nome === null) return 1;
		if (b.nome === "" || b.nome === null) return -1;

		if ( a.nome + " " + a.sobrenome > b.nome + " " + b.sobrenome ) {
			return -1;
		}
		if ( a.nome + " " + a.sobrenome < b.nome + " " + b.sobrenome ) {
			return 1;
		}
		return 0;

	}

	sortName(list) {
		if (this.state.order === "desc") { 
			return list.sort(this.compareDesc);
		} else if (this.state.order === "asc") {
			return list.sort(this.compare);
		}

	}
	// deus me perdoe por esse ctrl+c ctrl+V de codigo
	compareUsername( a, b) {
		if ( a.username < b.username ) {
			return -1;
		}
		if ( a.username > b.username ) {
			return 1;
		}
		return 0;
	}
	compareUsernameDesc( a, b) {
		if ( a.username > b.username ) {
			return -1;
		}
		if ( a.username < b.username ) {
			return 1;
		}
		return 0;
	}

	sortUsername(list) {

		if (this.state.orderUsername === "desc") {
			return list.sort(this.compareUsernameDesc);
		} else {
			return list.sort(this.compareUsername);
		}
	}

	filterByState() {
		const list = this.props.users.users;
		if (this.state.whichOrder === "nome") {
			return this.filterBySearchTerms(this.sortName(list));
		} else if (this.state.whichOrder === "username") {
			return this.filterBySearchTerms(this.sortUsername(list));
		}
	}

	renderUsers() {
		// let listaUsuarios = this.props.users.users;
		return ( <div className="user-listContainer">
			{this.getUsers().map((doc, i) =>
				<UsuarioItem							
					// isSelecting={exames.isSelecting}	
					index={i}
					key={doc.id}
					nome={doc.nome}
					sobrenome={doc.sobrenome}
					username={doc.username}
					email={doc.email}
					projeto={doc.projeto}
					id={doc.id}
					grupos={doc.grupos}
					redirect={this.props.redirectToEdit}
					deleteUser={this.props.deleteUser}				
				/>
			)}
		</div>
		);
	}

	renderAccessLog() {
		const { isAdminPlus } = this.props;
		if (isAdminPlus) {
			return (
				<div className="col-md-4">
					<button 
						type="button"
						
						className="btn btn-dark"
						onClick={() => {
							this.props.redirectToAccessLog();
						}}
						style={{float: "right", marginRight: "20px"}}
						>
						Histórico de Acesso
					</button>
				</div>
			);
		}
	}

	render () {
		return (
			<div className="container">
				<h2 className="text-center">Gerenciar Usuários</h2>	
				<br></br>
				<div className="text-center row" style={{marginLeft: "80px"}}>
					<div className="col-md-6 user-test" style={{float: "left", marginLeft: "-100px"}}>
						<form onSubmit={(e) => {
							e.preventDefault();
							e.stopPropagation();
							const tokens = this._filter.value.split(" ");
							const terms = [];
							tokens.map((t) => { 
								const parsed = RemoveAccents.remove(t.trim().normalize().toLowerCase());
								if ( parsed !== "" ) terms.push(parsed);
							});
							if ( terms.length > 0 ) {
								this.props.setSearchTerms(terms);
							} else {
								this.props.setSearchTerms([]);
							} 
						}}>
							<input
								type="text" 
								className="fas user-search form-control" 
								placeholder="&#xf002; " 
								ref={(node) => this._filter = node}
								onChange={(e) => {
									if ( e.target.value === "" ) {			
										this.props.setSearchTerms([]);
									}
								}}							
							/>
						</form>
					</div>
					{this.renderAccessLog()}
					<div className="col-md-2">
						<button 
							type="button"
							className="btn btn-dark"
							onClick={() => {
								this.props.redirectToCreate();
							}}
							style={{float: "right", marginRight: "20px"}}
							>
							Criar Novo Usuário
						</button>
					</div>
				</div>
				<br></br>
				
				<div className="headerManageUsers">
					<div className="categoria col-md-3" >
					{(this.state.order === "asc") 
						? <button className="user-OrderButton"
						onClick={(n) => this.setState({ order: "desc", whichOrder: "nome" })}>&#xf15e;</button>
						:	<button className="user-OrderButton"
						onClick={(n) => this.setState({ order: "asc", whichOrder: "nome" })}>&#xf881;</button>
						} Nome
					</div>
					<div className="categoria col-md-3">
					{(this.state.orderUsername === "asc") 
						? <button className="user-OrderButton" 
						onClick={(n) => this.setState({orderUsername: "desc", whichOrder: "username"})}>&#xf15e;</button>
						:	<button className="user-OrderButton" 
						onClick={(n) => this.setState({orderUsername: "asc", whichOrder: "username"})}>&#xf881;</button>
					}usuário</div>
					<div className="categoria col-md-3">e-mail</div>
					<div className="categoria col-md-3">Editar</div>
				</div>			
				{this.renderUsers()}
				<Pagination 
					pagination={this.props.users.pagination} 
					setPage={this.props.setCurrentPage}
					totalPages={this.getTotalPages()}
					totalDocuments={this.getTotalUsers()}
					paginationName="Usuários"
				/>
			</div>
		);
	}
}

GerenciarUsurios.propTypes = {
	isFetching: PropTypes.bool.isRequired,
	users: PropTypes.object.isRequired,
	getListUsers: PropTypes.func.isRequired,
	redirectToEdit: PropTypes.func.isRequired,
	redirectToCreate: PropTypes.func.isRequired,
	redirectToAccessLog: PropTypes.func.isRequired,
	deleteUser: PropTypes.func.isRequired,
	setCurrentPage: PropTypes.func.isRequired,
	setSearchTerms: PropTypes.func.isRequired,
	isAdminPlus: PropTypes.bool.isRequired
};


// WEBPACK FOOTER //
// ./src/components/ManageUser/GerenciarUsurios.js